export default __webpack_public_path__ + "static/media/save-icon.87b8cfa8.svg";